import React from 'react';

const Footer=(props)=>{
    return (
        <footer className="footer">
        <div className="footer-inner-wraper">
        <div className="row justify-content-between">
        <div className="col-auto">
            <div className=" ">
            <span className="text-muted d-block text-center text-sm-left d-sm-inline-block">© Copyright Motilal Oswal Asset Management Company Ltd.</span>            
            </div>
            </div>
            <div className="col-auto">
            <div className="text-muted mt-md-0 mt-2">
            Mutual Fund investments are subject to market risks, read all scheme related documents carefully.
            </div>
        </div>
            </div>
        </div>
        {!props.isQuickLoginPage ? 
        <div className="footer-inner-wraper">
            <div className="mt-2">
            <span className="text-left best-site-txt"> Site best viewed in Google Chrome (Latest version), Firefox (Latest version), Safari (Latest version), Microsoft Edge(Latest version)</span>
            </div>
        </div> : null}
        </footer>
    )
}

export default Footer